import React from 'react';
import { CustomSettings } from '../components';
import { withRouter } from 'us.common/wIthRouter';
import { useNavigate } from 'react-router-dom';
// import { withRouter, RouteComponentProps } from 'react-router-dom';

// interface ICnt_CustomSettings extends RouteComponentProps {
interface ICnt_CustomSettings {

}


const Cnt_CustomSettings = (props: ICnt_CustomSettings) => {
    const navigate = useNavigate();
    const onMinimize = () => {
        // props.history.push('')
        navigate('')
    }

    return (
        <CustomSettings.Home onMinimize={onMinimize} />
    )
}

export default withRouter(Cnt_CustomSettings);